/**
 * Query keys del dominio Actividad de usuarios.
 *
 * Keys consistentes y serializables (`docs/frontend_conventions.md`, Datos). El
 * resumen filtra por la sede activa (el backend lo hace vía `X-Sede-Id`), así que su
 * key incluye la sede para **cachear por sede**: al cambiar de sede, el resumen se
 * recarga (clave distinta) en vez de mostrar el de la sede anterior, igual que el
 * dashboard. También segmenta por período. El detalle por usuario no filtra por
 * sede (igual que el SSR), pero se segmenta por la ventana en días.
 */
import type { ActivityPeriod } from "../schemas";

/** Raíz de todas las queries de actividad (para invalidación amplia). */
export const ACTIVITY_ROOT_KEY = ["user_activity"] as const;

/** Key del resumen agregado, segmentada por sede activa y período. */
export function activitySummaryQueryKey(
  sedeId: number | null,
  period: ActivityPeriod,
) {
  return ["user_activity", "summary", { sede: sedeId, period }] as const;
}

/** Key del detalle/timeline de un usuario, segmentada por usuario y ventana en días. */
export function activityDetailQueryKey(username: string, days: number) {
  return ["user_activity", "detail", { username, days }] as const;
}
